import { render, staticRenderFns } from "./ReaderDemo.vue?vue&type=template&id=cd3dd8fc&scoped=true&"
import script from "./ReaderDemo.vue?vue&type=script&lang=js&"
export * from "./ReaderDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3dd8fc",
  null
  
)

export default component.exports